import React from "react";
import DatePicker from "react-datepicker";

const RangeDatePicker = React.forwardRef((props, ref) => (
  <div className="form-control-wrap">
    <DatePicker
      className={`form-control date-picker ${props.className || ''}`}
      dateFormat={"dd/MM/yy"}
      {...props}
      ref={ref}
    />
  </div>
));

export default RangeDatePicker;
